import { Modal } from 'antd';
import { DeleteFilled, ReloadOutlined } from '@ant-design/icons';
import { 
  BrandedModalProps, 
  HighSafetyBrandedModalProps, 
  DeleteModalProps, 
  ResetModalProps
} from './types';
import {
  ENFORCED_BUTTON_TYPES,
  ENFORCED_MODAL_TEXT_YES,
  ENFORCED_MODAL_TEXT_NO
} from './constants';

const { confirm } = Modal;

/**
 * Generic confirmation modal (strict - requires okType)
 */
function showCommonConfirmModal(props: BrandedModalProps): ReturnType<typeof confirm> {
  return confirm({
    ...props,
    centered: true,
    width: 416,
    styles: { 
      mask: { backdropFilter: 'blur(4px)' } 
    },
  });
};

/**
 * Base for high-risk modals that require strict safety behavior.
 */
function showHighSafetyDangerConfirmModal(props: HighSafetyBrandedModalProps): ReturnType<typeof confirm> {
  return showCommonConfirmModal({
    ...props,
    maskClosable: false,
    autoFocusButton: 'cancel',
    okButtonProps: { danger: true },
  });
};

/**
 * Standardized Delete confirmation.
 */
export function showDeleteConfirmModal(props: DeleteModalProps): ReturnType<typeof confirm> {
  return showHighSafetyDangerConfirmModal({
    ...props,
    okText: ENFORCED_MODAL_TEXT_YES.DELETE,
    cancelText: ENFORCED_MODAL_TEXT_NO.CANCEL,
    icon: <DeleteFilled style={{ color: '#ff4d4f' }} />,
    okType: ENFORCED_BUTTON_TYPES.DANGER, 
  });
};
export const showActiveConfirmModal = (props: DeleteModalProps) => {
  showHighSafetyDangerConfirmModal({
    ...props,
    okText: ENFORCED_MODAL_TEXT_YES.CONFIRM,
    cancelText: ENFORCED_MODAL_TEXT_NO.CANCEL,
    icon: <DeleteFilled style={{ color: '#ff4d4f' }} />,
    okType: ENFORCED_BUTTON_TYPES.DANGER, 
  });
};

/**
 * Standardized Reset confirmation.
 */
export function showResetConfirmModal(props: ResetModalProps): ReturnType<typeof confirm> {
  return showHighSafetyDangerConfirmModal({
    ...props,
    okText: ENFORCED_MODAL_TEXT_YES.RESET,
    cancelText: ENFORCED_MODAL_TEXT_NO.CANCEL,
    icon: <ReloadOutlined style={{ color: '#1677ff' }} />,
    okType: ENFORCED_BUTTON_TYPES.PRIMARY, 
  });
};
